export default __webpack_public_path__ + "static/media/arrows.82aa50b7.svg";